import { TextLink } from 'baby-design'
import { termsOfUsePath } from 'lib/urls'

const SMS_OPT_IN_DISCLAIMER = `By opting in, you consent to receive recurring automated promotional and personalized marketing text messages from Babylist at the provided number. Consent is not a condition of any purchase. Reply STOP to cancel at any time. Msg frequency varies. Msg and data rates may apply.`

export const SmsOptInDisclaimerCopy = () => (
  <>
    {SMS_OPT_IN_DISCLAIMER} View{' '}
    <TextLink
      underline
      href={termsOfUsePath}
      size="md"
      target="_blank"
      weight="regular"
    >
      Terms & Conditions
    </TextLink>
    .
  </>
)
